import request from '@/utils/request'
// import qs from 'qs'

// 分页查看脚本
export const scriptList = (getData) => {
  return request({
    url: '/back/script/pageList',
    method: 'get',
    headers: {
      'content-type': 'application/json'
    },
    // data: postData
    params: getData
  })
}
// 根据id查询
export const getScript = (getData) => {
  return request({
    url: '/back/script/getById',
    method: 'get',
    headers: {
      'content-type': 'application/json'
    },
    params: getData
  })
}
// 删除脚本
export const deleteScript = (getData) => {
  return request({
    url: '/back/script/deleteById',
    method: 'get',
    headers: {
      'content-type': 'application/json'
    },
    params: getData
  })
}
// 修改脚本
export const updateScript = (postData) => {
  return request({
    url: '/back/script/update',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data: postData
  })
}

// 新增脚本
export const addScript = (postData) => {
  return request({
    url: '/back/script/save',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data: postData
  })
}
// 运行脚本
export const runScript = (postData) => {
  return request({
    url: '/back/script/runScript',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data: postData
  })
}
